import { useId } from "react"

import { Checkbox, Flex, Form, Text } from "@/atoms"
import { InformationAlert } from "@/molecules/InformationAlert"
import { usesKaiCondition } from "@/pages/GovernancePage/helpers/workflows"

import type { StatusActionType } from "@/api/useWorkflow.types"
import type { FormInstance } from "@/atoms"
import { StatusReason } from "@/pages/TriagePage/components/molecules/DismissModal/StatusReason/StatusReason"

import styles from "../ActionsSectionForm.module.scss"

import type { ActionProps } from ".."

export interface ChangeStatusActionProps extends ActionProps {
  form: FormInstance
  status: StatusActionType
}

export const ChangeStatusAction = (props: ChangeStatusActionProps) => {
  const { t, path, status, form } = props
  const keyPrefix = `triage.${status}_modal`
  const conditions = Form.useWatch("currentConditions", form)
  const showUndismissOnKai =
    status === "dismiss" && usesKaiCondition(conditions)
  const undismissOnKaiHelpId = useId()

  return (
    <div className={styles.actionExtraFields}>
      {status === "dismiss" && (
        <InformationAlert
          message={
            <ul className={styles.list}>
              <li>{t(`${keyPrefix}.explainWorkflow`)}</li>
              <li>{t(`${keyPrefix}.excludeFromSummary`)}</li>
              <li>{t(`${keyPrefix}.priority`)}</li>
            </ul>
          }
          className={styles.informationAlert}
        />
      )}
      <StatusReason name={[path, "reason"]} status={status} t={t} />
      {showUndismissOnKai && (
        <Flex vertical gap={4} className={styles.undismissOnKai}>
          <Form.Item
            noStyle
            name={[path, "undismissOnKaiConfirmed"]}
            valuePropName="checked"
            // unset = on: new rules and rules saved before the option existed
            getValueProps={(value) => ({ checked: value !== false })}
          >
            <Checkbox aria-describedby={undismissOnKaiHelpId}>
              <Text strong>{t(`${keyPrefix}.undismissOnKaiConfirmed`)}</Text>
            </Checkbox>
          </Form.Item>
          <Text
            id={undismissOnKaiHelpId}
            type="secondary"
            className={styles.undismissOnKaiHelp}
          >
            {t(`${keyPrefix}.undismissOnKaiConfirmedHelp`)}
          </Text>
        </Flex>
      )}
    </div>
  )
}
